var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createHttpClient } from './http-client';
import { getAppPath, getFreeFormPathPart, getTaskFormFullPath, mapFormResponse, mapResponse } from './api.utils';
import { throwHttpError } from '../utils/result.utils';
var url = {
    getApplications: 'applications',
    getActions: 'actions',
    getProcesses: 'bpmn/process-definition',
    getTasks: 'bpmn/tasks',
    startProcessById: 'bpmn/process-definition',
    startProcessByKey: 'bpmn/process/key',
    startProcessByApp: 'bpmn/process/application',
    getForm: 'forms',
    getModalForm: 'button/modalform',
    closeModalForm: 'button/modalform',
    nextForm: 'button/nextForm',
    saveForm: 'button/save',
    addBlock: 'button/addBlock',
    updateBlock: 'button/updateBlock',
    removeBlock: 'button/deleteBlock',
    click: 'button/click',
    logList: 'log/list',
};
var XbpmApiService = /** @class */ (function () {
    function XbpmApiService(config, handlers) {
        var _this = this;
        this.loadApplication = function () {
            return _this.httpClient
                .get(url.getApplications)
                .then(mapResponse, throwHttpError("\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0441\u043F\u0438\u0441\u043E\u043A \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0439"));
        };
        this.loadProcesses = function (params) {
            return _this.httpClient
                .get(url.getProcesses, { params: params })
                .then(mapResponse, throwHttpError("\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0441\u043F\u0438\u0441\u043E\u043A \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u043E\u0432"));
        };
        this.loadTasks = function (params) {
            return _this.httpClient
                .get(url.getTasks, { params: params })
                .then(mapResponse, throwHttpError("\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0441\u043F\u0438\u0441\u043E\u043A \u0437\u0430\u0434\u0430\u0447"));
        };
        this.startProcessById = function (processDefinitionId) {
            return _this.httpClient
                .post(url.startProcessById + "/" + processDefinitionId)
                .then(mapFormResponse, throwHttpError("\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0437\u0430\u043F\u0443\u0441\u0442\u0438\u0442\u044C \u044D\u043A\u0437\u0435\u043C\u043F\u043B\u044F\u0440 \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u0430 [processDefinitionId = " + processDefinitionId + "]"));
        };
        this.startProcessByKey = function (processDefinitionKey, params) {
            var force = params.force, rest = __rest(params, ["force"]);
            // do not mutate params
            var paramss = __assign(__assign({}, rest), (force ? { force: true } : {}));
            return _this.httpClient
                .post(url.startProcessByKey + "/" + processDefinitionKey, null, { params: paramss })
                .then(mapFormResponse, throwHttpError("\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0437\u0430\u043F\u0443\u0441\u0442\u0438\u0442\u044C \u044D\u043A\u0437\u0435\u043C\u043F\u043B\u044F\u0440 \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u0430 [processDefinitionKey = " + processDefinitionKey + "]"));
        };
        this.startProcessByApp = function (pathParams, force) {
            var params = force ? { force: true } : undefined;
            var applicationGroup = pathParams.applicationGroup, applicationCode = pathParams.applicationCode, applicationVersion = pathParams.applicationVersion;
            return _this.httpClient
                .post(url.startProcessByApp + "/" + applicationGroup + "/" + applicationCode + "/" + applicationVersion, null, { params: params })
                .then(mapFormResponse, throwHttpError("\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0437\u0430\u043F\u0443\u0441\u0442\u0438\u0442\u044C \u044D\u043A\u0437\u0435\u043C\u043F\u043B\u044F\u0440 \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u0430 \u043F\u043E  \u0440\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u0430\u043C \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F [group = " + applicationGroup + ", code = " + applicationCode + ", version = " + applicationVersion + "]"));
        };
        // xbpm act
        this.fetchActForm = function (pathParams, params) {
            var applicationGroup = pathParams.applicationGroup, applicationCode = pathParams.applicationCode, applicationVersion = pathParams.applicationVersion, action = pathParams.action;
            return _this.httpClient
                .post(getAppPath(url.getApplications, pathParams) + "/" + url.getActions + "/" + action, params)
                .then(mapFormResponse, throwHttpError("\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0444\u043E\u0440\u043C\u0443 [group = " + applicationGroup + ", code = " + applicationCode + ", version = " + applicationVersion + ", action = " + action + "]"));
        };
        // task form
        this.fetchForm = function (pathParams) {
            var fullPath = getTaskFormFullPath(url.getForm, pathParams);
            return _this.httpClient
                .get(fullPath)
                .then(mapFormResponse, throwHttpError("\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0444\u043E\u0440\u043C\u0443 [processInstanceId = " + pathParams.processInstanceId + ", taskDefinitionKey = " + pathParams.taskDefinitionKey + "]"));
        };
        this.fetchModalForm = function (pathParams, frontData) {
            var fullPath = getTaskFormFullPath(url.getModalForm, pathParams);
            return _this.httpClient
                .post(fullPath, frontData)
                .then(mapFormResponse, throwHttpError("\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0444\u043E\u0440\u043C\u0443 [" + fullPath + "]"));
        };
        this.closeModalForm = function (pathParams, frontData) {
            var fullPath = getTaskFormFullPath(url.closeModalForm, pathParams);
            return _this.httpClient
                .put(fullPath, frontData)
                .then(mapFormResponse, throwHttpError("\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0437\u0430\u043A\u0440\u044B\u0442\u044C \u0444\u043E\u0440\u043C\u0443 [" + fullPath + "]"));
        };
        this.nextForm = function (pathParams, frontData) {
            var fullPath = getTaskFormFullPath(url.nextForm, pathParams);
            return _this.httpClient.post(fullPath, frontData).then(mapFormResponse, throwHttpError("\u041E\u0448\u0438\u0431\u043A\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438"));
        };
        this.saveForm = function (pathParams, frontData) {
            var fullPath = getTaskFormFullPath(url.saveForm, pathParams);
            return _this.httpClient.post(fullPath, frontData).then(mapFormResponse, throwHttpError("\u041E\u0448\u0438\u0431\u043A\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438"));
        };
        this.addBlock = function (pathParams, frontData) {
            var fullPath = getTaskFormFullPath(url.addBlock, pathParams);
            return _this.httpClient.post(fullPath, frontData).then(mapFormResponse, throwHttpError("\u041E\u0448\u0438\u0431\u043A\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438"));
        };
        this.updateBlock = function (pathParams, frontData) {
            var fullPath = getTaskFormFullPath(url.updateBlock, pathParams);
            return _this.httpClient.post(fullPath, frontData).then(mapFormResponse, throwHttpError("\u041E\u0448\u0438\u0431\u043A\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438"));
        };
        this.removeBlock = function (pathParams, frontData) {
            var fullPath = getTaskFormFullPath(url.removeBlock, pathParams);
            return _this.httpClient.post(fullPath, frontData).then(mapFormResponse, throwHttpError("\u041E\u0448\u0438\u0431\u043A\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438"));
        };
        this.click = function (pathParams, frontData) {
            var fullPath = getTaskFormFullPath(url.click, pathParams);
            return _this.httpClient.post(fullPath, frontData).then(mapFormResponse, throwHttpError("\u041E\u0448\u0438\u0431\u043A\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438"));
        };
        // free form
        this.fetchFreeForm = function (pathParams) {
            var applicationGroup = pathParams.applicationGroup, applicationCode = pathParams.applicationCode, applicationVersion = pathParams.applicationVersion, freeFormCode = pathParams.freeFormCode, force = pathParams.force, $kind = pathParams.$kind, queryObj = __rest(pathParams, ["applicationGroup", "applicationCode", "applicationVersion", "freeFormCode", "force", "$kind"]);
            var query = queryObj
                ? "?" + Object.entries(queryObj)
                    .map(function (pair) { return pair[0] + "=" + encodeURIComponent(pair[1]); })
                    .join('&')
                : '';
            var path = getAppPath(url.getApplications, pathParams) + "/" + getFreeFormPathPart(url.getForm, pathParams) + query;
            return _this.httpClient
                .get(path)
                .then(mapFormResponse, throwHttpError("\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0444\u043E\u0440\u043C\u0443 [group = " + applicationGroup + ", code = " + applicationCode + ", version = " + applicationVersion + ", form = " + freeFormCode + "]"));
        };
        this.saveFreeForm = function (pathParams, frontData) {
            var path = getAppPath(url.getApplications, pathParams) + "/" + getFreeFormPathPart(url.saveForm, pathParams);
            return _this.httpClient.post(path, frontData).then(mapFormResponse, throwHttpError("\u041E\u0448\u0438\u0431\u043A\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438"));
        };
        this.addFreeFormBlock = function (pathParams, frontData) {
            var path = getAppPath(url.getApplications, pathParams) + "/" + getFreeFormPathPart(url.addBlock, pathParams);
            return _this.httpClient.post(path, frontData).then(mapFormResponse, throwHttpError("\u041E\u0448\u0438\u0431\u043A\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438"));
        };
        this.updateFreeFormBlock = function (pathParams, frontData) {
            var path = getAppPath(url.getApplications, pathParams) + "/" + getFreeFormPathPart(url.updateBlock, pathParams);
            return _this.httpClient.post(path, frontData).then(mapFormResponse, throwHttpError("\u041E\u0448\u0438\u0431\u043A\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438"));
        };
        this.removeFreeFormBlock = function (pathParams, frontData) {
            var path = getAppPath(url.getApplications, pathParams) + "/" + getFreeFormPathPart(url.removeBlock, pathParams);
            return _this.httpClient.post(path, frontData).then(mapFormResponse, throwHttpError("\u041E\u0448\u0438\u0431\u043A\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438"));
        };
        // log
        this.logFormulas = function (entries) { return _this.httpClient.post(url.logList, { entries: entries }); };
        this.httpClient = createHttpClient(config, handlers);
    }
    return XbpmApiService;
}());
export { XbpmApiService };
//# sourceMappingURL=api.js.map